import Button from "react-bootstrap/esm/Button";
import { React, useState, useEffect, useContext, useRef } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "./ServiceTable.css";
import ClipLoader from "react-spinners/ClipLoader";
import Table from "react-bootstrap/Table";
import Select from "react-select";
import { ItemPriorityName } from "../../../helper";
import { findPriorityName } from "../../../helper";
import GlobalContext from "../../../providers/GlobalProvider";

export default function ServiceTable() {
  const IASLiveMapper = "IAS Libra Live";
  const { defaultMapper } = useContext(GlobalContext);
  let initialState = [];
  const [matchesList, setMatchesList] = useState(initialState);
  const [selectedPriority, setSelectedPriority] = useState({
    id: "",
    name: "",
  });
  const [selectedService, setSelectedService] = useState({ id: "", name: "" });
  const [selectedVendor, setSelectedVendor] = useState({
    accountId: "",
    description: "",
  });
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [selectedCustomer, setSelectedCustomer] = useState({
    accountId: "",
    description: "",
  });
  const [filteredServices, setFilteredServices] = useState([]);
  const [filteredVendors, setFilteredVendors] = useState([]);
  const [filteredCustomers, setFilteredCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const isIasMapper = defaultMapper == IASLiveMapper;
  const BASEURL = "/api/Category";

  const findService = (array, id) => {
    const selectedObj = array.find(
      (obj) => obj.id.toUpperCase() === id.toUpperCase()
    );
    if (selectedObj) {
      const name = selectedObj.name;
      const objIndex = array.findIndex(
        (obj) => obj.id.toUpperCase() === id.toUpperCase()
      );

      return name;
    }
    return "N/A";
  };
  const splitServiceIds = (obj) => obj.serviceCategoryId.split("/");
  const getIasServiceName =(array, obj) => findService(array, obj.serviceCategoryId);
  const getPrfdServiceName =(array,obj) => findService(array,splitServiceIds(obj)[0].trim());
  const getData = async () => {
    try {
      let response = await axios.get(BASEURL);
      const { service, vendor, customer, categoryMatching } = response.data;
      const newMatches = categoryMatching.map((obj) => ({
        id: obj.id,
        priority: findPriorityName(splitServiceIds(obj)[1]),
        service: {
          id: isIasMapper
            ? obj.serviceCategoryId
            : splitServiceIds(obj)[0].trim(),
          name: isIasMapper
            ? getIasServiceName(service, obj)
            : getPrfdServiceName(service, obj),
        },
        vendor: {
          accountId: obj.vendorAccountNo,
          description: findItem(vendor, obj.vendorAccountId),
        },
        customer: {
          accountId: obj.customerAccountNo,
          description: findItem(customer, obj.customerAccountId),
        },
      }));

      setFilteredServices(service);
      setFilteredVendors(vendor);
      setFilteredCustomers(customer);
      setMatchesList([...matchesList, ...newMatches]);
      setLoading(false);
    } catch (e) {
      console.error(e);
    }
  };

  const findItem = (array, id) => {
    const selectedObj = array.find((obj) => obj.accountId === id);
    if (selectedObj) {
      const description = selectedObj.description;
      return description;
    }
    return "N/A";
  };

  

  useEffect(() => {
    getData();
  }, [defaultMapper]);

  // move to utils file
  const filterService = (array, selectedId) => {
    if (!selectedId) return array;
    return array.filter((obj) => obj.id != selectedId);
  };

  const getOptionLabel = (option, displayProperty) => option[displayProperty];
  const getOptionValue = (option, idProperty) => option[idProperty];
  const getPriorityOptionLabel = (option) => getOptionLabel(option, "name");
  const getPriorityOptionValue = (option) => getOptionValue(option, "id");

  const getServiceOptionLabel = (option) => getOptionLabel(option, "name");
  const getServiceOptionValue = (option) => getOptionValue(option, "id");

  const getVendorOptionLabel = (option) =>
    getOptionLabel(option, "description");
  const getVendorOptionValue = (option) => getOptionValue(option, "accountId");

  const getCustomerOptionLabel = (option) =>
    getOptionLabel(option, "description");
  const getCustomerOptionValue = (option) =>
    getOptionValue(option, "accountId");

  const handleSaveClick = async (e) => {
    let existingService = matchesList.find(
      (obj) => obj.serviceCategoryId == selectedService.id
    );
    if (!existingService) {
      try {
        const newMatch = {
          priority: selectedPriority.name || "N/A",
          service:
            selectedPriority.id == null || selectedPriority.id == ""
              ? { id: selectedService.id, name: selectedService.name }
              : {
                  id: `${selectedService.id}/${selectedPriority.id}`,
                  name: selectedService.name,
                },
          vendor: {
            id: selectedVendor.accountId || 0,
            description: selectedVendor.description || "N/A",
          },
          customer: {
            id: selectedCustomer.accountId || 0,
            description: selectedCustomer.description || "N/A",
          },
        };
        // service required, vendor or customer
        if (
          newMatch.service.id &&
          (newMatch.vendor.id || newMatch.customer.id)
        ) {
          const matchesData = {
            ServiceCategoryId: newMatch.service.id,
            VendorAccountId: newMatch.vendor.id,
            CustomerAccountId: newMatch.customer.id,
          };
          let response = await axios.post(BASEURL, matchesData);

          if (response.status == 200) {
            setError("");
            setSuccess("Data saved successfully!");
            setTimeout(() => {
              setSuccess("");
            }, 1000);
            setMatchesList([...matchesList, newMatch]);
            setSelectedPriority({ id: "", name: "" });
            setSelectedService({ id: "", name: "" });
            setSelectedCustomer({ accountId: "", description: "" });
            setSelectedVendor({ accountId: "", description: "" });
          }
        }
      } catch (e) {
        if (e.response?.status == 409) {
          setError(e.response.data);
          setSuccess("");
        }
      }
    } else {
      setError("Missing Data!");
      setSuccess("");
      return;
    }
  };

  const handleServiceChange = (event) => {
    if (event) {
      const selectedId = event.id;
      const selectedName = event.name;

      setSelectedService({
        id: selectedId,
        name: selectedName,
      });
    }
  };
  const handlePriorityChange = (event) => {
    if (event) {
      const selectedId = event.id;
      const selectedName = event.name;

      setSelectedPriority({
        id: selectedId,
        name: selectedName,
      });
    }
  };

  const handleVendorChange = (event) => {
    if (event) {
      const selectedId = event.accountId;
      const selectedDescription = event.description;

      setSelectedVendor({
        accountId: selectedId,
        description: selectedDescription,
      });
    }
  };

  const handleDeleteClick = async (service, matchId) => {
    try {
      const updatedMatches = matchesList.filter(
        (match) => match.service.id !== service.id
      );
      setMatchesList(updatedMatches);

      await axios.delete(`${BASEURL}/${matchId}`);
    } catch (e) {
      console.error("Error deleting this match", e);
    }
  };

  const handleCustomerChange = (event) => {
    if (event) {
      const selectedId = event.accountId;
      const selectedDescription = event.description;

      setSelectedCustomer({
        accountId: selectedId,
        description: selectedDescription,
      });
    }
  };

  if (loading) {
    return (
      <div>
        <ClipLoader
          loading={loading}
          size={100}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      </div>
    );
  }

  return (
    <>
      <Table hover bordered="false" responsive order>
        <thead>
          <tr>
            {!isIasMapper && <th>Priority</th>}
            <th>Service</th>
            {!isIasMapper && <th>Vendor</th>}
            <th>Customer</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {matchesList && matchesList.length > 0 ? (
            matchesList.map((match) => {
              const priority = match.priority;
              const serviceData = match.service;
              const customerData = match.customer;
              const vendorData = match.vendor;

              return (
                <tr
                  key={
                    serviceData.id +
                    vendorData.description +
                    customerData.description
                  }
                >
                  {defaultMapper != IASLiveMapper && <td>{priority}</td>}
                  <td>{serviceData.name}</td>
                  {defaultMapper != IASLiveMapper && (
                    <td>{vendorData.description}</td>
                  )}
                  <td>{customerData.description}</td>

                  <td>
                    <Button
                      variant="outline-danger"
                      onClick={() => handleDeleteClick(match.service, match.id)}
                    >
                      Delete
                    </Button>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="4">No matches found</td>
            </tr>
          )}
          <tr>
            {!isIasMapper && (
              <td>
                <div>
                  <Select
                    menuPlacement="top"
                    options={ItemPriorityName}
                    getOptionLabel={(option) => getPriorityOptionLabel(option)}
                    getOptionValue={(option) => getPriorityOptionValue(option)}
                    onChange={handlePriorityChange}
                    isClearable={true}
                    isSearchable={true}
                    placeholder="Select an option"
                  />
                </div>
              </td>
            )}
            <td>
              <div>
                <Select
                  menuPlacement="top"
                  options={filteredServices}
                  getOptionLabel={(option) => getServiceOptionLabel(option)}
                  getOptionValue={(option) => getServiceOptionValue(option)}
                  onChange={handleServiceChange}
                  isClearable={true}
                  isSearchable={true}
                  placeholder="Select an option"
                />
              </div>
            </td>
            {!isIasMapper && (
              <td>
                <div>
                  <Select
                    menuPlacement="top"
                    options={filteredVendors}
                    getOptionLabel={(option) => getVendorOptionLabel(option)}
                    getOptionValue={(option) => getVendorOptionValue(option)}
                    onChange={handleVendorChange}
                    isClearable={true}
                    isSearchable={true}
                    placeholder="Select an option"
                  />
                </div>
              </td>
            )}
            <td>
              <div>
                <Select
                  menuPlacement="top"
                  options={filteredCustomers}
                  getOptionLabel={(option) => getCustomerOptionLabel(option)}
                  getOptionValue={(option) => getCustomerOptionValue(option)}
                  onChange={handleCustomerChange}
                  isClearable={true}
                  isSearchable={true}
                  placeholder="Select an option"
                />
              </div>
            </td>
            {selectedService.id != "" &&
            (selectedVendor.accountId != "" ||
              selectedCustomer.accountId != "") ? (
              <td>
                <Button
                  variant="outline-success"
                  onClick={handleSaveClick}
                  style={{ marginTop: "0px" }}
                >
                  Save
                </Button>
              </td>
            ) : (
              <td></td>
            )}
          </tr>
        </tbody>
      </Table>
      {error && (
        <div>
          <h4 style={{ color: "red" }}>{error}</h4>
        </div>
      )}
      {success && (
        <div>
          <h4 style={{ color: "green" }}>{success}</h4>
        </div>
      )}
      <Link to="/">
        <Button variant="outline-danger">Main Menu</Button>
      </Link>
    </>
  );
}
